import { render, staticRenderFns } from "./PanelContentItemLatencyAlarmMessage.vue?vue&type=template&id=762fa68e&"
import script from "./PanelContentItemLatencyAlarmMessage.vue?vue&type=script&lang=ts&"
export * from "./PanelContentItemLatencyAlarmMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports